export const formatNumber = (value, money = false) => {
  let options = money ? { style: 'currency', currency: 'BRL' } : {}
  return parseFloat(value).toLocaleString('pt-BR', options)
}



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Helpers.js